/* eslint-disable prefer-destructuring */
const envObj = process.env;
export const isGAMMA = envObj.NODE_ENV === 'gamma';
export const CURRENT_NODE_ENV = envObj.NODE_ENV;
export const POSTHOG_API_KEY = envObj.POSTHOG_API_KEY;
export const POSTHOG_API_HOST = envObj.POSTHOG_API_HOST;
export const SENTRY_DSN = process.env.SENTRY_DSN;
export const GTM_ID = process.env.GTM_ID;

/**
 * Returns true when reCAPTCHA should be bypassed.
 * Bypass is allowed in all envs when ?recpt=0 is present in the URL.
 * Mirrors the same query-param bypass logic used by Google login (skipReCaptcha in commonauth-ui).
 */
export const byPassCaptcha = () => {
  return new URLSearchParams(window.location.search).get('recpt') === '0';
};
